import { render, staticRenderFns } from "./siteSettingsWVI.vue?vue&type=template&id=00045e17&"
import script from "./siteSettingsWVI.vue?vue&type=script&lang=js&"
export * from "./siteSettingsWVI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports